import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from './base.service';
import { Observable } from 'rxjs';
import { Message } from 'node_modules/@progress/kendo-angular-conversational-ui/chat/api';

@Injectable({
  providedIn: 'root'
})
export class SessionsService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'sessions');
  }

  getConversation(sessionId: string): Observable<Message[]> {
    return this._http.get<Message[]>(this._baseUrl + `/${sessionId}/conversation`);
  }

  getClientSession(userId: string, clientToken: string): Observable<any> {
    return this._http.get<Message[]>(this._baseUrl + `/${userId}/${clientToken}`);
  }

  getAllClientSessions(userId: string): Observable<any> {
    return this._http.get<any[]>(this._baseUrl + `/${userId}`);
  }

}

